/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FcbUserCentresLiesGridDto
 */
export interface FcbUserCentresLiesGridDto {
    /**
     * 
     * @type {number}
     * @memberof FcbUserCentresLiesGridDto
     */
    idcentre?: number;
    /**
     * 
     * @type {string}
     * @memberof FcbUserCentresLiesGridDto
     */
    nom?: string | null;
}

/**
 * Check if a given object implements the FcbUserCentresLiesGridDto interface.
 */
export function instanceOfFcbUserCentresLiesGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbUserCentresLiesGridDtoFromJSON(json: any): FcbUserCentresLiesGridDto {
    return FcbUserCentresLiesGridDtoFromJSONTyped(json, false);
}

export function FcbUserCentresLiesGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbUserCentresLiesGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idcentre': !exists(json, 'idcentre') ? undefined : json['idcentre'],
        'nom': !exists(json, 'nom') ? undefined : json['nom'],
    };
}

export function FcbUserCentresLiesGridDtoToJSON(value?: FcbUserCentresLiesGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idcentre': value.idcentre,
        'nom': value.nom,
    };
}

